import { render, staticRenderFns } from "./carList.vue?vue&type=template&id=2f23c786&scoped=true"
import script from "./carList.vue?vue&type=script&lang=js"
export * from "./carList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23c786",
  null
  
)

export default component.exports